import styled from 'styled-components'
import { space } from 'styled-system'

import { default as VARIABLES } from '../../themes/styles/variables'

import { ICONS } from '../../themes'

export const SectionStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  width: 100%;

  /* Styled System
  ------------------------------- */
  ${space}

  * {
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_1};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_4};
    }

    scrollbar-width: thin; //Bug scroll ff
  }

  /* Child element styles
  ------------------------------- */
  .text-center {
    justify-content: center;
  }

  /* Modifiers
  ------------------------------- */
  &.table-scroll {
    max-height: 400px;
    overflow: auto;
    flex-wrap: wrap;
  }

  /* follow to boostaps */
  &.row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .col-auto,
    .col-1,
    .col-2,
    .col-3,
    .col-4,
    .col-5,
    .col-6,
    .col-7,
    .col-8,
    .col-9,
    .col-10,
    .col-11,
    .col-12 {
      flex: 0 0 auto;
    }

    .col-auto {
      width: auto;
    }

    .col-1 {
      width: 8.33333333%;
    }

    .col-2 {
      width: 16.66666667%;
    }

    .col-3 {
      width: 25%;
    }

    .col-4 {
      width: 33.33333333%;
    }

    .col-5 {
      width: 41.66666667%;
    }

    .col-6 {
      width: 50%;
    }

    .col-7 {
      width: 58.33333333%;
    }

    .col-8 {
      width: 66.66666667%;
    }

    .col-9 {
      width: 75%;
    }

    .col-10 {
      width: 83.33333333%;
    }

    .col-11 {
      width: 91.66666667%;
    }

    .col-12 {
      width: 100%;
    }
  }

  &.row-history {
    justify-content: end !important;
    margin-bottom: 1em;
    div.button {
      width: 100px;
    }
  }
  &.approval-step-main {
    margin: 1em;
  }
  &.attachment-approval {
    margin: 1em 0;
  }
  &.note-approval {
    margin: 1em;
  }

  &.approval-workflow {
    gap: 1rem;
    margin-bottom: 2rem;
  }
  &.approval-step {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: auto;
    
    img {
      min-width: 25px;
      height: 25px;
    }

    .approval-step-requester {
      flex-direction: column;
      background-color: #4b4acb;
      flex: 0 0 14%;
      min-width: 190px;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      min-height: 60px;
      text-align: center;
      flex-wrap: wrap;
      margin: 10px 0;
      border: 1px solid #4b4acb;
      padding: 1rem 1.5rem;

      p {
        color: white;
        font-size: 0.9rem;

        &.p-decoration {
          text-decoration: underline;
        }
      }
    }
    .approval-step-approved {
      background-color: #16A651;
      border: 1px solid #16A651;
      p.p-decoration {
        text-decoration: underline;
      }
    }
    .approval-step-approving {
      background-color: white;
      border: 1px solid #FC8601;
      p {
        color: #FC8601;
      }
      p.p-decoration {
        text-decoration: underline;
      }
    }
    .approval-step-reject {
      background-color: #E24132;
      border: 1px solid #E24132;
      p.p-decoration {
        text-decoration: underline;
      }
    }
    .approval-step-Inactive {
      background-color: #BBBBBB;
      border: 1px solid #BBBBBB;
      p {
        color: #707070;
      }
      p.p-decoration {
        text-decoration: underline;
      }
    }
    .approval-step-pending {
      background-color: white;
      border: 1px solid #FC8601;
      p {
        color: #FC8601;
      }
      p.p-decoration {
        text-decoration: underline;
      }
    }
    .cursor-pointer{
        cursor: pointer;
    }
    .or-and-class-first-pending {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-bottom: 2px solid #FC8601;
      margin: unset;
    }
    .or-and-class-last-pending {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      border-bottom: 1px solid #FC8601;
      margin: unset;
    }
    .or-and-class-first-approving {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-bottom: 2px solid #FC8601;
      margin: unset;
    }
    .or-and-class-last-approving {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      border-bottom: 1px solid #FC8601;
      margin: unset;
    }
    .or-and-class-first-approved {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-bottom: 2px solid #16A651;
      margin: unset;
    }
    .or-and-class-last-approved {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      border-bottom: 1px solid #16A651;
      margin: unset;
    }
    .or-and-class-first-reject {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-bottom: 2px solid #E24132;
      margin: unset;
    }
    .or-and-class-last-reject {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      border-bottom: 1px solid #E24132;
      margin: unset;
    }
    .or-and-class-first-Inactive {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-bottom: 2px solid #BBBBBB;
      margin: unset;
    }
    .or-and-class-last-Inactive {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      border-bottom: 1px solid #BBBBBB;
      margin: unset;
    }
    .or-and-class-pending {
      border-bottom: 2px solid #FC8601;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      margin: unset;
    }
    .or-and-class-approving {
      border-bottom: 2px solid #FC8601;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      margin: unset;
    }
    .or-and-class-approved {
      border-bottom: 2px solid #16A651;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      margin: unset;
    }
    .or-and-class-reject {
      border-bottom: 2px solid #E24132;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      margin: unset;
    }
    .or-and-class-Inactive {
      border-bottom: 2px solid #BBBBBB;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      margin: unset;
    }
    .main-or-and {
      margin: 10px 0;
      flex-basis: 0;
    }
    .app-hr {
      width: 50%;
      margin: 7px auto;
    }
    .app-hr.padding {
      border-top: 2px solid #FC8601;
    }
    .app-hr.approving {
      border-top: 2px solid #FC8601;
    }
    .app-hr.approved {
      border-top: 2px solid #49f590;
    }
    .app-hr.reject {
      border-top: 2px solid #f5877d;
    }
    .app-hr.inactive {
      border-top: 2px solid #707070;
    }
  }
  #predecessor-pro-event {
    .select__indicator {
      display: none;
    }
  }
  #compare_event_pro_category {
    .select__indicator {
      display: none;
    }
  }
  &.forgot-passwprd-form {
    flex-wrap: wrap;
    max-width: 320px;

    .button {
      margin-top: 20px;
    }
  }

  .style-table {
    max-height: 22vh;
    overflow-x: unset;
    overflow-y: auto;
    /* width */
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  &.link-edit-center {
    justify-content: center;
  }

  .last-update {
    color: ${VARIABLES.COLORS.BLUE_1};
  }

  /* Page Title */
  &.page-topbar {
    justify-content: space-between;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    align-items: center;
    margin-bottom: 0;
    gap: 16px;

    .page-header {
      width: auto;
      min-width: 0;
      flex: 1;
      align-items: center;

      .page-icon {
        flex: 0 0 44px;
        height: 44px;
        justify-content: center;
        align-items: center;
        background-color: #6c63ff;
        border-radius: 12px;
        margin-right: 12px;

        .image-control {
          height: 24px;
          width: auto;

          .image {
            vertical-align: initial;
            height: 100%;
          }
        }
      }

      .title-and-breadcrumb {
        flex-wrap: wrap;
        cursor: default;

        .title {
          width: 100%;
          font-size: 20px;
          color: #1f2937;
          font-weight: 700;
          line-height: 1.25;
          white-space: nowrap;
        }
      }
    }

    .page-button {
      width: auto;
    }
  }

  &.main-content {
    background-color: transparent;
    border-radius: 0;
    width: 100%;
    max-width: 100%;
    padding: 0;
    align-items: flex-start;
    flex-wrap: wrap;
    min-width: 0;
    flex: 1;
    box-shadow: none;

    &:not(.form) {
      padding: 0;
      background-color: transparent;
    }

    .content-body {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      flex-wrap: wrap;

      .form-actions {
        /* margin-top: 50px;
        padding: 0 30px; */
      }
    }

    .content-footer {
      justify-content: space-between;
      align-items: center;
      align-self: auto;
      flex: 0 0 auto;
      flex-wrap: nowrap;
      box-sizing: border-box;
      width: 100%;
      height: 40px;
      min-height: 40px;
      max-height: 40px;
      margin-top: 12px;
      margin-bottom: 0;
      padding: 6px 16px;
      border-radius: 12px;
      background-color: #ffffff;
      box-shadow: 0 2px 8px rgba(31, 41, 55, 0.04);
      font-size: 13px;
      line-height: 1;
      color: #64748b;

      .showing-item {
        width: auto;
        flex: 0 0 auto;
        color: #94a3b8;
        font-size: 13px;
        line-height: 28px;
        white-space: nowrap;
      }

      .paginate-wrapper {
        width: auto;
        flex: 0 0 auto;
        align-items: center;
        gap: 8px;
        flex-direction: row-reverse;

        .pagination-wrapper,
        .paginations {
          height: 28px;
        }

        .moveto-wrapper {
          align-items: center;
          justify-content: flex-end;
          gap: 6px;
          margin: 0;
          height: 28px;

          .button {
            width: auto;
            min-width: 36px;
            height: 28px !important;
            min-height: 28px !important;
            max-height: 28px !important;
            padding: 0 10px;
            border-radius: 8px;
            font-weight: 500;
            text-transform: capitalize;
            font-size: 12px;
            line-height: 28px;
            box-sizing: border-box;
          }

          .paginate-moveto {
            width: 96px;
            height: 28px !important;
            min-height: 28px !important;
            max-height: 28px !important;
            flex-wrap: nowrap;
            align-items: center;
            box-sizing: border-box;

            .label {
              flex: 0 0 auto;
              margin: 0;
              font-size: 12px;
              line-height: 28px;
            }

            .input {
              height: 28px !important;
              min-height: 28px !important;
              max-height: 28px !important;
              padding: 0 6px;
              border-radius: 8px;
              font-size: 12px;
              line-height: 26px;
              box-sizing: border-box;
            }
          }
        }
      }
    }

    &.form {
      min-height: calc(100vh - 267px);
      align-items: stretch;
      background-color: #ffffff;
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(31, 41, 55, 0.04);
      overflow: hidden;

      .content-body {
        align-content: space-between;
      }

      .form-actions {
        margin-top: 50px;
        padding: 0 30px;
      }
    }
  }

  &.flex-grow-0 {
    flex-grow: 0;
  }

  /*----------------------------
  ----------   Table  ----------
  ----------------------------*/
  &.table-responsive {
    overflow-x: auto;
    margin-bottom: 1rem;
  }

  &.table-filter {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    gap: 12px;
    padding: 16px;
    margin-bottom: 12px;
    border-radius: 12px;
    background-color: #ffffff;
    box-shadow: 0 2px 8px rgba(31, 41, 55, 0.04);
  }

  &.table-wrapper {
    overflow-x: auto;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding-bottom: 0;
    flex-direction: column;
  }

  &.table-header-freeze-wrapper {
    width: 100%;
    flex-wrap: wrap;
  }

  /*----------------------------
  ----------   form  -----------
  ----------------------------*/
  &.form-wrapper {
    flex-wrap: wrap;
    padding: 30px;

    .result-image {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      border: 1px solid ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
      width: 200px;
      height: 113px;
      position: relative;
      align-items: stretch;
      justify-content: center;
      overflow: hidden;

      .button {
        width: 100%;
        height: 100%;

        .image-control {
          width: 100%;
          height: 100%;

          .image {
            object-fit: cover;
          }
        }
      }

      & > .image-control {
        width: 49px;
      }
    }

    .info-wrapper {
      flex: 1 1 auto;
      width: auto;
      align-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;

      .detail-group {
        margin-bottom: 14px;
        color: #1f2937;

        .label {
          flex: 0 0 200px;
          padding-right: 50px;
          font-weight: 600;
        }

        .data-control {
          display: flex;
        }
      }
    }
  }

  &.form-actions {
    justify-content: flex-end;
    align-items: center;

    .button {
      width: 125px;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &.form-row {
    flex-wrap: wrap;
    justify-content: space-between;
    /* margin-left: -20px;
    width: calc(100% + 20px); */

    &.form-row-title {
      margin-bottom: 21px;
    }
  }

  &.form-col {
    flex-wrap: wrap;
    //padding: 0 10px;
    &.col-3 {
      flex: 0 0 auto;
      width: 25%;
    }

    &.col-6 {
      flex: 0 0 50%;
      max-width: 662px;
      /* padding-left: 20px; */

      .form-group {
        //padding: 0;

        .input-textarea-control {
          .textarea {
            width: 100%;
          }
        }
      }
    }
  }

  &.textRightTotal {
    justify-content: flex-end;
  }

  &.form-group-title {
    background-color: ${VARIABLES.COLORS.BLUE_1};
    padding: 12px 30px;
    color: white;
    border-radius: ${VARIABLES.BORDER_RADIUSES.TN};
    margin-bottom: 30px;
    font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
  }

  &.form-group-header {
    color: #1f2937;
    font-weight: 700;
    margin-top: 8px;
    margin-bottom: 30px;

    &.small-bottom-space {
      margin-bottom: 10px;
    }

    &.grid-to-label {
      padding-left: 10%;
      /* 66px */
    }
  }

  &.form-group {
    align-items: flex-start;

    .form-group-up {
      margin-top: 10px;
      margin-left: 33px;


      & > label {

        flex: 0 0 132px;
        color: #1f2937;
        font-weight: 600;
        display: flex;
        text-align: right;
        margin-right: 30px;
        line-height: 1.25;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
        min-height: 42px;

      }

      .form-group-control {
        flex: 1 1 auto;
        flex-wrap: wrap;
        margin-top: 40px;

        .input-control {
          &.score {
            max-width: 80px;
            flex: 0 0 80px;
            min-width: 80px;

            .input {
              text-align: center;
              color: ${VARIABLES.COLORS.BLUE_1};
            }
          }
        }
      }

      .form-group-inner-wrapper {
        min-height: 42px;
        align-items: center;

        .button {
          width: 125px;

          &:first-child {
            margin-left: 0;
          }
        }

        &.checkbox {
          flex-wrap: wrap;

          & > .checkbox {
            margin-top: 8px;
            margin-right: 0;

            .fake-label {
              color: #1f2937;
            }
          }
        }
      }

    }

    .form-group-inner-wrapper {
      min-height: 42px;
      align-items: center;

      .button {
        width: 125px;

        &:first-child {
          margin-left: 0;
        }
      }

      &.checkbox {
        flex-wrap: wrap;

        & > .checkbox {
          margin-top: 8px;
          margin-right: 0;

          .fake-label {
            color: #1f2937;
          }
        }
      }
    }

    & > label {
      flex: 0 0 132px;
      color: #1f2937;
      font-weight: 600;
      display: flex;
      text-align: right;
      margin-right: 30px;
      line-height: 1.25;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
      min-height: 42px;
    }

    & > text {
      flex: 0 0 auto;
      color: #1f2937;
      display: flex;
      text-align: right;
      margin-right: 30px;
      line-height: 1.25;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
      min-height: 42px;
      white-space: pre-wrap;
    }

    .text {
      color: #1f2937;
    }

    .input-upload-control {
      max-width: 640px;
      flex: 0 0 640px;
      min-width: 250px;

      .fake-input-label {
        flex: 1 1 auto;
        margin-right: 0;
        display: initial;
      }
    }

    .form-group-control {
      flex: 1 1 auto;
      flex-wrap: wrap;

      .input-control {
        &.score {
          max-width: 80px;
          flex: 0 0 80px;
          min-width: 80px;

          .input {
            text-align: center;
            color: ${VARIABLES.COLORS.BLUE_1};
          }
        }
      }
    }

    .input-control {
      max-width: 500px;
      //flex: 0 0 500px;
      //min-width: 250px;
    }

    .input-textarea-control {
      //flex: 0 0 500px;
      /* max-width: 500px; //อย่าใส่ค่ะ กระทบทุกหน้าเลย by noolek //class นี้เป็น class ของ textarea component ค่ะ*/
      //min-width: 250px;
    }

    .button {
      /* width: auto;*/
      margin-left: 14px;

      &.verify {
        flex: 0 0 140px;
      }

      &.resend-activation-email {
        flex: 0 0 230px;
      }
    }

    .message {
      height: 20px;
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
      color: ${VARIABLES.COLORS.RED_1};
      margin-bottom: 10px;
      padding-left: 14px;
      opacity: 0;

      &.is-password {
        margin-left: 220px;
      }
    }

    .select-control {
      width: 100%;
      max-width: 500px;
    }

    .note {
      width: auto;
      color: ${VARIABLES.COLORS.BLUE_1};
      line-height: 1.25;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
      min-height: 42px;
      margin-left: 14px;
    }

    &.is-error {

      label {
        color: ${VARIABLES.COLORS.RED_1};
      }

      .input-control {
        .input {
          border-color: ${VARIABLES.COLORS.RED_1};
        }
      }

      .react-datepicker-wrapper {
        border-color: ${VARIABLES.COLORS.RED_1};
      }

      &.labelname {
        label {
          color: #1f2937;
        }
      }

      .input-textarea-control {
        .textarea {
          border-color: ${VARIABLES.COLORS.RED_1};
        }
      }


      .select__control {
        border-color: ${VARIABLES.COLORS.RED_1};
      }

      .input-upload-control {
        .fake-input-label {
          .fake-input {
            border-color: ${VARIABLES.COLORS.RED_1};
          }
        }
      }

      .dropdown-container {
        border-color: ${VARIABLES.COLORS.RED_1};
      }

      .message {
        opacity: 1;
      }
    }

    &.service-category {
      .form-group-inner-wrapper {
        flex-wrap: wrap;
      }
      .add {
        .image-control {
          margin-right: 11px;
        }
      }
    }

    &.user-role {
      .checkbox-group {
        margin-top: 8px;

        .checkbox {
          .fake-label {
            color: #1f2937;
          }
        }
      }
    }
  }

  .tooltip-upload {
    position: relative;
    width: auto;

    .tooltip-attachment {
      /* position: absolute;
      width: 18px;
      top: 50%;
      right: -23px;
      text-align: left;
      transform: translateY(-50%);
      z-index: 10; */
      position: absolute;
      width: 18px;
      /* top: 0; */
      right: -23px;
      /* margin-top: 3px; */
    }

    .__react_component_tooltip{
      min-width: 400px;

      &.background-white {
        color: ${VARIABLES.COLORS.GRAY_3};
      }
    }
  }

  /*----------------------------
  -----   filter sidebar  ------
  ----------------------------*/
  &.filter-sidebar-wrapper {
    flex: 0 0 23%;
    flex-wrap: wrap;
    padding: 60px 25px;
    margin-top: -60px;

    .title {
      color: ${VARIABLES.COLORS.BLUE_1};
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XXL};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_BOLD};
      margin-bottom: 39px;
      justify-content: center;
    }

    .filter-group-header {
      color: ${VARIABLES.COLORS.BLUE_1};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
      /* align-items: center; */
      margin-bottom: 8px;

      &:before {
        content: '';
        display: inline-block;
        width: 10px;
        flex: 0 0 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${VARIABLES.COLORS.BLUE_1};
        margin-right: 10px;
        margin-top: 8px;
      }
    }

    .filter {
      padding: 8px 14px;
      flex-wrap: wrap;

      .sub-group {
        flex-wrap: wrap;
      }

      &.is-float-inside {
        position: relative;
        height: 44px;
        padding: 0;
        z-index: ${VARIABLES.Z_INDEXS.LV_3};

        .filter-group-header {
          margin-bottom: 0;
        }

        .accordion {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          /* max-height: calc(100vh - 200px);
          overflow-y: auto; */

          .accordion-body {
            /* max-height: calc(100vh - 25vw); */
            overflow-y: auto;
            margin-right: -13px;
            width: auto;
            margin-bottom: 2px;
            padding-right: 6px;

            /* width */
            ::-webkit-scrollbar {
              width: 5px;
            }

            /* Track */
            ::-webkit-scrollbar-track {
              background: ${VARIABLES.COLORS.GRAY_2};
            }

            /* Handle */
            ::-webkit-scrollbar-thumb {
              background: ${VARIABLES.COLORS.BLUE_4};
            }

            /* Handle on hover */
            ::-webkit-scrollbar-thumb:hover {
              background: ${VARIABLES.COLORS.BLUE_1};
            }
          }

          &.is-open {
            .accordion-body {
              max-height: calc(100vh - 25vw);
            }
          }
        }

        .checkbox-group {
          .checkbox {
            &:last-child {
              margin-bottom: 10px;
            }
          }
        }
      }
    }

    .checkbox {
      .fake-label {
        color: #1f2937;
      }
    }

    /* .slider-wrapper {
      margin-bottom: 20px;
    } */

    .select-control {
      margin-bottom: 20px;
      width: 100%;
    }
  }

  &.checkbox-group {
    margin-bottom: 4px;
    padding-left: 20px;
    flex-wrap: wrap;

    .sub-group {
      padding-left: 30px;
      flex-wrap: wrap;
    }

    .checkbox {
      margin-bottom: 10px;
      width: 100%;
      justify-content: flex-start;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.inside-filter {
    flex-wrap: wrap;
    /* margin-top: 30px; */
    border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_11};
    padding-left: ${VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT + 'px'};
    padding-right: 36px;
    padding-bottom: 22px;

    .filters {
      gap: 30px;
      flex-wrap: wrap;
      margin-bottom: 10px;
    }

    /* .filters {
      gap: 10px;
      width: auto;
      align-items: center;
    } */

    .filter-item {
      width: auto;
      display: flex;
      white-space: nowrap;
      align-items: center;
      gap: 15px;

      .label {
        flex-direction: column;
      }
    }

    .label {
      color: #1f2937;
      font-weight: 600;
      white-space: nowrap;
      width: auto;
    }

    /* .search-note {
      font-size: 14px;
      color: #848484;
    } */

    /* .action-wrapper {
      align-items: center;
      margin-bottom: 8px;
      gap: 15px;

      .filters {
        align-items: center;
        width: auto;
        flex: 1 1 auto;
        max-width: 600px;
        padding-right: 35px;

        .total-supplier {
          width: auto;
          margin-right: 16px;
          white-space: nowrap;
          display: flex;
          flex-direction: column;
        }

        .input-search-control {
          &.supplier-discovery {
            flex: 1 1 auto;
            min-width: 220px;
            max-width: 450px;
          }
        }

        .search-note {
          white-space: nowrap;
          font-size: 14px;
          margin-left: 0;
        }
      }

      .sort-by-wrapper {
        //flex: 0 0 290px;
        align-items: center;
        //margin-left: 36px;
        width: auto;

        .label {
          color: #1f2937;
          font-weight: 600;
          white-space: nowrap;
          margin-right: 15px;
        }

        .select-control {
          &.category-filter {
            min-width: 220px;
          }
        }
      }
    } */

    .sort-by-wrapper {
      .label {
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      }
    }

    .search-tags {
      min-height: 12px;
      flex-wrap: wrap;

      .tag {
        margin-bottom: 7px;
        margin-right: 10px;
      }
    }

    .search-note {
      /* white-space: nowrap; */
      font-size: 14px;
      /* margin-left: 0px;
      color: #848484; */
    }

    /* .total-supplier {
      width: auto;
      margin-right: 16px;
      white-space: nowrap;
      display: flex;
      flex-direction: column;
    } */
  }

  /*----------------------------
  -----   Supplier Discovery block  ------
  ----------------------------*/
  &.supplier-discovery-block {
    min-height: 255px;
    /* padding-left: ${
      VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT + 'px'
    };
    padding-top: 17px;
    padding-bottom: 41px; */
    padding: 26px 36px 26px 45px;
    border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_11};
    flex-wrap: wrap;

    .signs {
      gap: 10px;
      align-items: flex-start;
    }

    .status {
      padding: 0 14px;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 24px;
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
      border-radius: ${VARIABLES.BORDER_RADIUSES.MD};
    }

    .registration-status {
      border: 1px solid ${VARIABLES.COLORS.GRAY_15};
      color: ${VARIABLES.COLORS.GRAY_15};
    }

    .active-status {
      border: 1px solid ${VARIABLES.COLORS.GREEN_1};
      color: ${VARIABLES.COLORS.GREEN_1};
    }

    .seal-status {
      border: 1px solid ${VARIABLES.COLORS.GREEN_1};
      color: ${VARIABLES.COLORS.GREEN_1};
    }

    .not-regis-status {
      border: 1px solid ${VARIABLES.COLORS.GRAY_15};
      color: ${VARIABLES.COLORS.GRAY_15};
    }

    .wait-active-status {
      border: 1px solid ${VARIABLES.COLORS.YELLOW_1};
      color: ${VARIABLES.COLORS.YELLOW_1};
    }

    .actions {
      margin-left: 5%;
      flex: 0 0 231px;
      flex-wrap: wrap;
      padding-top: 50px;
      align-content: flex-start;

      .button {
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  &.supplier-discovery-information {
    cursor: default;
    flex-wrap: wrap;

    .header-info {
      width: 100%;
    }

    .info-outer-wrapper {
      width: 100%;
    }

    .info-wrapper {
      flex-wrap: wrap;
    }

    .group-with-scoreboard {
      gap: 15px;

      .detail-groups {
        flex-direction: column;
      }
    }

    .data-control {
      display: flex;
      gap: 10px;
      align-items: flex-start;

      a {
        text-decoration: underline;
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
        color: ${VARIABLES.COLORS.BLUE_2};
      }
    }

    .detail-group {
      margin-bottom: 15px;
      color: #1f2937;

      > .label {
        flex: 0 0 220px;
        max-width: 220px;
        padding-right: 2rem;
        text-align: right;
        font-weight: 600;
      }

      .status {
        border-radius: ${VARIABLES.BORDER_RADIUSES.MD};
        font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
        display: flex;
        flex: none;
        padding: 0 14px;
        align-items: center;
        height: 24px;

        &.registration-status {
          border: 1px solid ${VARIABLES.COLORS.GRAY_15};
          color: ${VARIABLES.COLORS.GRAY_15};
        }

        &.active-status {
          border: 1px solid ${VARIABLES.COLORS.GREEN_1};
          color: ${VARIABLES.COLORS.GREEN_1};
        }

        &.not-regis-status {
          border: 1px solid ${VARIABLES.COLORS.GRAY_15};
          color: ${VARIABLES.COLORS.GRAY_15};
        }

        &.wait-active-status {
          border: 1px solid ${VARIABLES.COLORS.YELLOW_1};
          color: ${VARIABLES.COLORS.YELLOW_1};
        }
      }

      .data-control {
        .data {
          /* a {
            text-decoration: underline;
            font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
            color: ${VARIABLES.COLORS.BLUE_2};

            &.file-link {
              background-color: ${VARIABLES.COLORS.GRAY_7};
              border: 1px solid ${VARIABLES.COLORS.GRAY_2};
              display: inline-flex;
              align-items: center;
              padding: 7px 17px 7px 42px;
              width: 100%;
              max-width: 500px;
              border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
              text-decoration: none;
              margin-bottom: 10px;
              position: relative;
              margin-right: 10px;
              cursor: pointer;

              &:before {
                content: '';
                display: inline-block;
                background-image: url(${ICONS['icon-download-file.png']});
                width: 13px;
                height: 16px;
                margin-right: 15px;
                position: absolute;
                top: 50%;
                left: 19px;
                transform: translateY(-50%);
              }
            }

            &:hover {
              color: ${VARIABLES.COLORS.BLUE_5};
            }
          } */

          .table {
            &.contact-detail {
              margin-top: -12px;

              .table-column {
                color: ${VARIABLES.COLORS.BLUE_1};
              }

              .full-name {
                max-width: calc(((100% - 200px) / 2) + 25px);
                /* min-width: 270px; */
              }

              .phone {
                max-width: 200px;
                /* min-width: 165px; */
              }

              .email {
                max-width: calc(((100% - 200px) / 2) - 25px);
                /* min-width: 270px; */
              }
            }
          }
        }
      }

      .file-link {
        background-color: #F7F7F7;
        border: 1px solid #CCCCCC;
        display: flex;
        align-items: center;
        padding: 7px 17px 7px 42px;
        width: 100%;
        border-radius: 6px;
        text-decoration: none;
        position: relative;
        margin-right: 10px;
        cursor: pointer;

        &:before {
          content: '';
          display: inline-block;
          background-image: url(${ICONS['icon-download-file.png']});
          width: 13px;
          height: 16px;
          margin-right: 15px;
          position: absolute;
          top: 50%;
          left: 19px;
          transform: translateY(-50%);
        }
      }
    }

    .actions {
      margin-left: 5%;
      flex: 0 0 231px;
      flex-wrap: wrap;
      align-content: flex-start;

      .button {
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  &.supplier-management-information {
    flex-wrap: wrap;

    .info-wrapper {
      flex: 1 1 auto;
      width: auto;
      align-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;

      .detail-group {
        margin-bottom: 14px;
        color: #1f2937;

        .label {
          flex: 0 0 250px;
          padding-right: 50px;
          text-align: right;
          font-weight: 600;
        }

        .data-control {
          display: flex;
          flex-wrap: wrap;
          width: 100%;

          .data {
            display: flex;
            // width: 100%;
          }

          .button {
            &.link {
              margin-left: 20px;
            }
          }

          .switch-wrapper {
            margin-top: 5px;
          }

          .registration-status {
            margin: 1px 0 0 16px;
            border: 1px solid ${VARIABLES.COLORS.GRAY_15};
            border-radius: ${VARIABLES.BORDER_RADIUSES.MD};
            padding: 0 14px;
            white-space: nowrap;
            color: ${VARIABLES.COLORS.GRAY_15};
            height: 24px;
            font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
            line-height: 22px;
          }

          .active-status {
            margin: 1px 0 0 10px;
            border: 1px solid ${VARIABLES.COLORS.GREEN_1};
            border-radius: ${VARIABLES.BORDER_RADIUSES.MD};
            padding: 0 14px;
            white-space: nowrap;
            color: ${VARIABLES.COLORS.GREEN_1};
            height: 24px;
            font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
            line-height: 22px;
          }

          .not-regis-status {
            margin: 1px 0 0 16px;
            border: 1px solid ${VARIABLES.COLORS.GRAY_15};
            border-radius: ${VARIABLES.BORDER_RADIUSES.MD};
            padding: 0 14px;
            white-space: nowrap;
            color: ${VARIABLES.COLORS.GRAY_15};
            height: 24px;
            font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
            line-height: 22px;
          }

           .wait-active-status {
            margin: 1px 0 0 16px;
            border: 1px solid ${VARIABLES.COLORS.YELLOW_1};
            border-radius: ${VARIABLES.BORDER_RADIUSES.MD};
            padding: 0 14px;
            white-space: nowrap;
            color: ${VARIABLES.COLORS.YELLOW_1};
            height: 24px;
            font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
            line-height: 22px;
          }

          .data {
            a {
              text-decoration: underline;
              font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
              color: ${VARIABLES.COLORS.BLUE_2};

              &.file-link {
                background-color: ${VARIABLES.COLORS.GRAY_7};
                border: 1px solid ${VARIABLES.COLORS.GRAY_2};
                display: inline-flex;
                align-items: center;
                padding: 7px 17px 7px 42px;
                width: 100%;
                max-width: 500px;
                border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
                text-decoration: none;
                margin-bottom: 10px;
                position: relative;
                margin-right: 10px;
                cursor: pointer;

                &:before {
                  content: '';
                  display: inline-block;
                  background-image: url(${ICONS['icon-download-file.png']});
                  width: 13px;
                  height: 16px;
                  margin-right: 15px;
                  position: absolute;
                  top: 50%;
                  left: 19px;
                  transform: translateY(-50%);
                }
              }

              &:hover {
                color: ${VARIABLES.COLORS.BLUE_5};
              }
            }

            .table {
              &.contact-detail {
                width: auto;
                margin-top: 15px;

                .table-column {
                  color: ${VARIABLES.COLORS.BLUE_1};
                }

                .full-name {
                  max-width: calc(((100% - 200px) / 2) + 25px);
                  /* min-width: 270px; */
                }

                .phone {
                  max-width: 300px;
                  /* min-width: 165px; */
                }

                .email {
                  max-width: calc(((100% - 200px) / 2) - 25px);
                  /* min-width: 270px; */
                }
              }
            }

            .search-tags {
              margin-top: 12px;
              flex-wrap: wrap;

              .tag {
                margin-bottom: 7px;
                margin-right: 10px;

                .button {
                  padding: 0;
                }
              }
            }

            &.red-text {
              color: ${VARIABLES.COLORS.RED_1};
              margin-top: 5px;
              flex-wrap: wrap;
              word-break: break-word;
              & > * {
                width: 100%;
              }
            }
          }

          .data-input {
            width: 100%;
            display: flex;

            .input-control {
              max-width: 400px;

              &.tag-relevant {
                width: 300px;
                margin-right: 10px;
              }
            }

            &.tag-relevant {

              .button {
                padding-left: 45px;
                padding-right: 45px;
              }
            }
          }
        }

        /* .button {
          padding: 0 15px;
          width: auto;
        } */

        &.attachment {
          .label {
            // padding-top: 8px;
          }

          .data-control {
            width: 100%;

            .data {
              width: 100%;
            }
          }
        }

        /* &.offline-comprehensive-assessment-score {
          .data-control {
            align-items: center;

            .data {
              margin-right: 40px;
            }
          }
        } */

        &.tag-relevant {
          .label {
            padding-top: 8px;
          }
        }
      }
    }
  }

  &.detail-wrapper {
    flex-wrap: wrap;

    .detail-group-title {
      cursor: default;
      background-color: ${VARIABLES.COLORS.BLUE_1};
      padding: 12px 30px;
      color: white;
      border-radius: ${VARIABLES.BORDER_RADIUSES.TN};
      margin-bottom: 30px;
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
    }
  }

  &.task-group {
    flex-wrap: wrap;
  }

  &.no-result-found {
    display: block;
    text-align: center;
    padding-top: 15vh;

    p {
      padding-top: 20px;
      color: ${VARIABLES.COLORS.GRAY_14};
      font-size: 20px;
    }

    img {
      width: 5%;
    }
  }
  &.no-result {
    display: block;
    text-align: center;
    padding-top: 5vh;
    margin-bottom: 60px;
    p {
      padding-top: 20px;
      color: ${VARIABLES.COLORS.GRAY_14};
      font-size: 20px;
    }

    img {
      width: 80px;
    }
  }
  &.code-of-practice {
    display: block;
    text-align: center;
    padding-top: 10vh;
    margin-bottom: 60px;
    p {
      padding-top: 40px;
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
    }
    img {
      width: 200px;
    }
    .accepted {
      color: #4b4acb;
    }
    .no-information {
      color: #CE1F0F;
    }
  }

  .file-link-edit {
    margin-right: unset !important;
    border: unset !important;
    padding: 7px 17px 7px 20px !important;
    text-decoration: underline !important;
    background-color: unset !important;
    margin-bottom: unset !important;
    ::before {
      margin-right: unset !important;
      left: 0 !important;
    }
  }
  &.attached-file-list {
    a#file-step3 {
      max-width: 100%;
    }
    a {
      text-decoration: none;
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
      color: ${VARIABLES.COLORS.BLUE_2};

      &.file-link {
        background-color: ${VARIABLES.COLORS.GRAY_7};
        border: 1px solid ${VARIABLES.COLORS.GRAY_2};
        /* display: inline-flex; */
        /* display: grid; */
        display: flex;
        /* display: inline-grid; */
        align-items: center;
        /* padding: 7px 17px 7px 42px; */
        padding: 7px 10px;
        /* width: auto; */
        /* max-width: 300px; */
        /* max-width: max-content; */
        border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
        text-decoration: none;
        margin-bottom: 10px;
        /* margin-right: 15px; */
        position: relative;
        cursor: pointer;
        /* max-width: calc(100% - 65px); */
        gap: 10px;

        .file-name {
          /* width: 100%; */
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-left: 20px;
          max-width: 520px;
          /* padding-right: 10px; */
        }

        &:before {
          content: '';
          display: block;
          background-image: url(${ICONS['icon-download-file.png']});
          width: 13px;
          height: 16px;
          /* padding-right: 15px; */
          position: absolute;
          /* top: 50%; */
          left: 10px;
          /* transform: translateY(-50%); */
        }

        .button {
          /* flex: 0 0 16px; */

          .delete-circle-icon {
            flex: 0 0 16px;
          }

          &:hover {
            filter: brightness(0.8);
          }
        }
      }

      /* &.removable {
        .file-name {
          width: calc(100% -);
        }
      } */

      &:hover {
        color: ${VARIABLES.COLORS.BLUE_5};
      }
    }
  }

  /*----------------------------
  -----   reset password form  ------
  ----------------------------*/
  /* &.reset-password-form {
    width: 100%;
    max-width: 320px;
    flex-wrap: wrap;
    margin-bottom: 100px;

    .input-control {
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }
    }

    .invalid-message {
      color: ${VARIABLES.COLORS.RED_1};
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
    }

    .button {
      margin-top: 36px;
      &.link {
        margin-top: 14px;
        width: 100%;
      }
    }
  } */
  /* Request Unseal Modal First */
  .popup-sourcing {
    overflow: auto;
    max-height: 600px;
    max-height: 60vh;
    display: flex;

    /* width */
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    }

    .tbody {
      width: 100%;
    }

    .header-freeze ~ .table {
      max-height: 550px;
      max-height: 60vh;
      display: flex;

      /* width */
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }
  }

  /*----------------------------
  ----- Request Unseal ------
  ----------------------------*/
  &.modalUnsealButton {
    justify-content: flex-end;
  }

  /* Request Unseal
  ------------------------------- */
  &.modalInput {
    justify-content: center;
    margin-bottom: 1em;
  }

  /*for noolek srm p2*/

  &.justify-content-end {
    justify-content: flex-end;
  }

  &.flex-column {
    flex-direction: column;
  }

  &.fluid {
    width: 100%;
  }

  &.form-group-outer {
    flex-direction: column;
  }

  &.width-auto {
    width: auto;
  }

  &.border-radius-6 {
    border-radius: 6px;
  }

  /* For noolek when merge srm to dev plz delete it!!!!
  ------------------------------- */
  &.table-responsive {
    overflow-x: auto;
    margin-bottom: 1rem;
  }

  /* Media queries
  ------------------------------- */
  @media (max-width: 1680px) {
    /* &.supplier-discovery-block {
      .info-wrapper {
        .supplier-header {
          .supplier-name-and-address {
            .supplier-address {
              max-height: none;
            }
          }
        }
      }
    } */

    /* &.inside-filter {
      margin-top: 25px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_XXL + 'px'
      };

      .action-wrapper {
        .filters {
          padding-right: 30px;

          .total-supplier {
            margin-right: 14px;
          }

          .input-search-control {
            &.supplier-discovery {
              min-width: 210px;
              max-width: 340px;
              width: auto;
            }
          }
        }
      }
    } */
  }

  /* @media all and (max-width: 1750.98px) {
    .form-col {
      &.col-6 {
        .countdown-filp-timer-wrapper {
          .flip-countdown {
            .flip-countdown-piece {
              .flip-countdown-card {
                padding-right: 10px;

                &:after {
                  font-size: 42px;
                }
              }
            }

            &.size-small {
              .flip-countdown-piece {
                .flip-countdown-card {
                  .flip-countdown-card-sec {
                    font-size: 32px;
                  }
                }
              }
            }
          }
        }
      }
    }
  } */

  @media all and (max-width: 1600.98px) {
    &.page-topbar {
      margin-bottom: 0;

      .page-header {
        .page-icon {
          flex: 0 0 44px;
          height: 44px;
          margin-right: 12px;

          .image-control {
            height: 22px;
          }
        }

        .title-and-breadcrumb {
          .title {
            font-size: 20px;
          }
        }
      }
    }

    &.main-content {
      padding: 25px;
      min-width: 0;

      .content-body {
        .form-actions {
          margin-top: 45px;
          padding: 0 25px;
        }
      }

      .content-footer {
        font-size: 14px;
      }

      &.form {
        min-height: calc(100vh - 267px);

        .form-actions {
          margin-top: 45px;
          padding: 0 25px;
        }
      }
    }

    .tooltip-upload {
      .tooltip-attachment {
        width: 17px;
        right: -21px;
      }
    }

    /*----------------------------
    -----   filter sidebar  ------
    ----------------------------*/
    /* &.filter-sidebar-wrapper {
      //flex: 0 0 ${VARIABLES.ELEMENT_SIZES.FILTER_SIDE_BAR_WIDTH_XL + 'px'};

      .title {
        font-size: 24px;
        margin-bottom: 37px;
      }

      .filter-group-header {
        &:before {
          width: 9px;
          flex: 0 0 9px;
          height: 9px;
          margin-right: 9px;
          margin-top: 7px;
        }
      }

      .filter {
        padding: 8px 14px;

        &.is-float-inside {
          height: 42px;

          .checkbox-group {
            .checkbox {
              &:last-child {
                margin-bottom: 9px;
              }
            }
          }
        }
      }

      .slider-wrapper {
        margin-bottom: 18px;
      }

      .select-control {
        margin-bottom: 18px;
      }
    } */

    /* &.inside-filter {
      margin-top: 20px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_XL + 'px'
      };

      .action-wrapper {
        .filters {
          padding-right: 25px;

          .total-supplier {
            margin-right: 14px;
          }

          .input-search-control {
            &.supplier-discovery {
              min-width: 210px;
              max-width: 340px;
            }
          }

          .search-note {
            font-size: 12px;
          }
        }

        .sort-by-wrapper {
          .select-control {
            &.category-filter {
              min-width: 200px;
            }
          }
        }
      }
    } */

    &.checkbox-group {
      padding-left: 18px;

      .checkbox {
        margin-bottom: 9px;
      }

      .sub-group {
        padding-left: 24px;
      }
    }

    /*----------------------------
    -----   Supplier Discovery block  ------
    ----------------------------*/
    /* &.supplier-discovery-block {
      min-height: 250px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_XL + 'px'
      };
      padding-top: 16px;
      padding-bottom: 39px;

      .info-wrapper {
        .supplier-header {
          margin-bottom: 25px;

          .supplier-name-and-address {
            min-width: 240px;

            .supplier-name-and-signs {
              padding-right: 33px;

              .supplier-name {
                font-size: 18px;
              }

              .signs {
                margin-left: 15px;
                padding-top: 1px;

                .button {
                  margin-right: 9px;

                  .image-control {
                    width: 19px;
                  }
                }

                .registration-status {
                  border-radius: 11px;
                  padding: 0 13px;
                  height: 23px;
                  line-height: 21px;
                }

                .active-status,
                .wait-active-status,
                .seal-status,
                .not-regis-status {
                  margin: 0 0 0 10px;
                  padding: 0 13px;
                  height: 23px;
                  line-height: 21px;
                }
              }
            }
          }
        }

        .supplier-info {
          .col {
            &:nth-child(2) {
              margin-left: 9px;

              .info-block {
                .label {
                  flex: 0 0 154px;
                }
              }
            }
          }

          .info-block {
            .label {
              flex: 0 0 146px;
              margin-right: 18px;
            }
          }
        }
      }

      .actions {
        flex: 0 0 225px;
        padding-top: 45px;

        .button {
          margin-bottom: 9px;
        }
      }
    } */

    /* &.supplier-discovery-information {
      .info-wrapper {
        .group-with-scoreboard {
          .detail-groups {
            min-width: 450px;
            padding-right: 20px;

            .detail-group {
              .label {
                width: 210px;
              }

              .data-control {
                min-width: 300px;
              }
            }
          }
        }

        .detail-group {
          margin-bottom: 13px;

          .label {
            flex: 0 0 200px;
            padding-right: 30px;
          }

          .data-control {
            .button {
              &.link {
                margin-left: 18px;
              }
            }

            .registration-status,
            .active-status,
            .not-regis-status,
            .wait-active-status {
              margin: 0 0 0 15px;
              border-radius: 11px;
              padding: 0 13px;
              height: 23px;
              font-size: 14px;
              line-height: 21px;
            }

            .data {
              a {
                &.file-link {
                  padding: 7px 16px 7px 40px;
                  max-width: 450px;
                  border-radius: 4px;
                  margin-bottom: 9px;
                  margin-right: 9px;

                  &:before {
                    width: 12px;
                    height: 15px;
                    margin-right: 14px;
                    left: 18px;
                  }
                }
              }
            }
          }
        }
      }

      .actions {
        flex: 0 0 200px;

        .button {
          margin-bottom: 9px;
        }
      }
    } */

    &.supplier-management-information {
      .info-wrapper {
        .detail-group {
          .data-control {
            .data {
              .table {
                &.contact-detail {
                  .table-column {
                    &.resend-activation-email {
                      padding-left: 10px;
                    }
                  }
                }
              }
            }
          }

          .label {
            flex: 0 0 230px;
            padding-right: 45px;
          }
        }
      }
    }

    /*----------------------------
    ----------   form  -----------
    ----------------------------*/
    &.form-wrapper {
      padding: 25px;

      /* .result-image {
        width: 200px;
        height: 113px;

        & > .image-control {
          width: 49px;
        }
      } */

      .info-wrapper {
        .detail-group {
          margin-bottom: 12px;

          .label {
            flex: 0 0 180px;
            padding-right: 45px;
          }

          .data-control {
            display: flex;
          }
        }
      }
    }

    &.form-actions {
      padding: 0 25px;
    }

    &.form-group {
      //padding: 0 10px;

      .form-group-up {
        & > label {
          flex: 0 0 132px;
          margin-right: 30px;
          min-height: 40px;
        }

        .form-group-control {
          margin-top: 40px;

          /* .input-control {
            &.score {
              max-width: 80px;
              flex: 0 0 80px;
              min-width: 80px;
            }
          } */
        }

        .form-group-inner-wrapper {
          min-height: 40px;

          /* .button {
            width: 125px;
          }

          &.checkbox {
            & > .checkbox {
              margin-top: 8px;
            }
          } */
        }

      }

      .form-group-inner-wrapper {
        min-height: 40px;

        /* .button {
          width: 125px;
        }

        &.checkbox {
          & > .checkbox {
            margin-top: 8px;
          }
        } */
      }

      & > label {
        flex: 0 0 132px;
        margin-right: 30px;
        min-height: 40px;
      }

      .input-upload-control {
        max-width: 500px;
        flex: 0 0 500px;
        min-width: 250px;
      }

      /* .form-group-control {
        .input-control {
          &.score {
            max-width: 80px;
            flex: 0 0 80px;
            min-width: 80px;
          }
        }
      } */

      .input-control {
        max-width: 100%;
        flex: 0 0 100%;
        min-width: 0;
      }

      .input-textarea-control {
        //max-width: calc(100% - 162px);
        flex: 0 0 100%;
        min-width: 0;
      }

      .button {
        margin-left: 14px;

        &.verify {
          flex: 0 0 130px;
        }

        &.resend-activation-email {
          flex: 0 0 210px;
        }
      }

      .message {
        padding-left: 12px;
        margin-bottom: 9px;

        &.is-password {
          margin-left: 200px;
        }
      }

      .note {
        flex-wrap: wrap;
        min-height: 40px;
        margin-left: 12px;
      }

      /* &.service-category {
        .add {
          .image-control {
            margin-right: 10px;
          }
        }
      }

      &.user-role {
        .checkbox-group {
          margin-top: 8px;
        }
      } */
    }

    &.form-col {
      &.col-6 {
        .form-group {
          .form-group-control {
            max-width: calc(50% - 162px);

            &.with-button {
              max-width: 100%;

              .form-group-inner-wrapper {
                .input-control {
                  max-width: calc(((100% + 195px + 30px) / 2 ) - 162px);
                }
              }
            }
          }

          .form-group-control {
            max-width: none;
          }

          .input-textarea-control {
            max-width: 100%;
          }
        }

        /* .countdown-filp-timer-wrapper {
          .flip-countdown {
            .flip-countdown-piece {
              .flip-countdown-card {
                padding-right: 10px;

                &:after {
                  font-size: 42px;
                }
              }
            }

            &.size-small {
              .flip-countdown-piece {
                .flip-countdown-card {
                  .flip-countdown-card-sec {
                    font-size: 35px;
                  }
                }
              }
            }
          }
        } */
      }
    }

    &.form-group-title {
      padding: 11px 25px;
      margin-bottom: 25px;
    }
  }

  @media all and (max-width: ${VARIABLES.BREAKPOINTS.DESKTOP_SM_MAX}) {
    &.supplier-discovery-block {
      padding: 15px;
      min-height: auto;
    }

    &.inside-filter {
      padding: 15px;
      padding-top: 0;
    }
  }

  @media all and (max-width: 1440.98px) {
    &.page-topbar {
      margin-bottom: 0;

      .page-header {
        .page-icon {
          flex: 0 0 44px;
          height: 44px;

          .image-control {
            height: 20px;
          }
        }

        .title-and-breadcrumb {
          .title {
            font-size: 20px;
          }
        }
      }
    }

    &.main-content {
      padding: 25px;
      min-width: 0;

      .content-body {
        .form-actions {
          margin-top: 40px;
          padding: 0 20px;
        }
      }

      .content-footer {
        font-size: 14px;
      }

      &.form {
        min-height: calc(100vh - 267px);

        .form-actions {
          margin-top: 40px;
          padding: 0 20px;
        }
      }
    }

    .tooltip-upload {
      .tooltip-attachment {
        width: 15px;
        right: -18px;
      }
    }

    &.no-result-found {

      p {
        padding-top: 20px;
        color: ${VARIABLES.COLORS.GRAY_14};
        font-size: 20px;
      }

      img {
        width: auto;
      }
    }

    /*----------------------------
    -----   filter sidebar  ------
    ----------------------------*/
    /* &.filter-sidebar-wrapper {
      padding: 0 15px;
      margin-top: 0;

      .title {
        font-size: 22px;
        margin-bottom: 35px;
      }

      .filter-group-header {
        &:before {
          width: 8px;
          flex: 0 0 8px;
          height: 8px;
          margin-right: 8px;
          margin-top: 6px;
        }
      }

      .filter {
        padding: 7px 11px;

        &.is-float-inside {
          height: 40px;

          .checkbox-group {
            .checkbox {
              &:last-child {
                margin-bottom: 8px;
              }
            }
          }
        }
      }

      .slider-wrapper {
        margin-bottom: 16px;
      }

      .select-control {
        margin-bottom: 16px;
      }
    } */

    /* &.inside-filter {
      margin-top: 15px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_LG + 'px'
      };

      .action-wrapper {
        .filters {
          padding-right: 20px;

          .input-search-control {
            &.supplier-discovery {
              min-width: 160px;
              max-width: 300px;
            }
          }

          .search-note {
            font-size: 11px;
          }

          .select-control {
            &.category-filter {
              min-width: 180px;

              .select__menu {
                min-width: 270px;
              }
            }
          }
        }

        .sort-by-wrapper {
          .select-control {
            &.category-filter {
              min-width: 190px;
            }
          }
        }
      }
    } */

    &.checkbox-group {
      padding-left: 15px;

      .checkbox {
        margin-bottom: 8px;
      }

      .sub-group {
        padding-left: 19px;
      }
    }

    /*----------------------------
    -----   Supplier Discovery block  ------
    ----------------------------*/
    /* &.supplier-discovery-block {
      min-height: 230px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_LG + 'px'
      };
      padding-top: 15px;
      padding-bottom: 37px;

      .info-wrapper {
        .supplier-header {
          margin-bottom: 20px;

          .supplier-name-and-address {
            min-width: 230px;

            .supplier-name-and-signs {
              padding-right: 31px;

              .supplier-name {
                font-size: 17px;
              }

              .signs {
                margin-left: 14px;

                .button {
                  margin-right: 8px;

                  .image-control {
                    width: 17px;
                  }
                }

                .registration-status {
                  border-radius: 10px;
                  padding: 0 12px;
                  height: 22px;
                  line-height: 20px;
                  font-size: 11px;
                }

                .active-status,
                .wait-active-status,
                .seal-status,
                .not-regis-status {
                  margin: 0 0 0 9px;
                  padding: 0 12px;
                  height: 22px;
                  line-height: 20px;
                  font-size: 11px;
                }
              }
            }

            .supplier-address {
              font-size: 13px;
            }
          }
        }

        .supplier-info {
          .col {
            &:nth-child(2) {
              margin-left: 8px;

              .info-block {
                .label {
                  flex: 0 0 145px;
                }
              }
            }
          }

          .info-block {
            .label {
              flex: 0 0 135px;
              margin-right: 15px;
            }
          }
        }
      }

      .actions {
        flex: 0 0 220px;
        padding-top: 40px;

        .button {
          margin-bottom: 8px;
        }
      }
    } */

    /* &.supplier-discovery-information {
      .info-wrapper {
        .group-with-scoreboard {
          .detail-groups {
            min-width: 300px;
            padding-right: 15px;

            .detail-group {
              .label {
                width: 180px;
              }

              .data-control {
                min-width: 230px;
              }
            }
          }
        }

        .detail-group {
          margin-bottom: 12px;

          .label {
            flex: 0 0 180px;
            padding-right: 15px;
          }

          .data-control {
            .button {
              &.link {
                margin-left: 17px;
              }
            }

            .registration-status,
            .active-status,
            .not-regis-status,
            .wait-active-status {
              margin: 0 0 0 14px;
              border-radius: 10px;
              padding: 0 12px;
              height: 22px;
              font-size: 13px;
              line-height: 20px;
            }

            .data {
              a {
                &.file-link {
                  padding: 6px 15px 6px 38px;
                  max-width: 350px;
                  border-radius: 3px;
                  margin-bottom: 8px;
                  margin-right: 8px;

                  &:before {
                    width: 11px;
                    height: 14px;
                    margin-right: 13px;
                    left: 17px;
                  }
                }
              }
            }
          }
        }
      }

      .actions {
        flex: 0 0 180px;

        .button {
          margin-bottom: 9px;
        }
      }
    } */

    &.supplier-management-information {
      .info-wrapper {
        .detail-group {
          .label {
            flex: 0 0 210px;
            padding-right: 35px;
          }
        }
      }
    }

    /*----------------------------
    ----------   form  -----------
    ----------------------------*/
    &.form-wrapper {
      padding: 20px;

      /* .result-image {
        width: 200px;
        height: 113px;

        & > .image-control {
          width: 49px;
        }
      } */

      .info-wrapper {
        .detail-group {
          margin-bottom: 11px;

          .label {
            flex: 0 0 160px;
            padding-right: 40px;
          }

          .data-control {
            display: flex;
          }
        }
      }
    }

    &.form-actions {
      padding: 0 20px;

      .button {
        width: 115px;
      }
    }

    &.form-group {
      .form-group-up {
        & > label {
          flex: 0 0 125px;
          margin-right: 30px;
          min-height: 38px;
        }

        .form-group-control {
          margin-top: 38px;
        }

        .form-group-inner-wrapper {
          min-height: 38px;
        }
      }

      .input-upload-control {
        max-width: 550px;
        flex: 0 0 550px;
        min-width: 220px;
      }

      .form-group-inner-wrapper {
        min-height: 38px;
      }

      & > label {
        flex: 0 0 132px;
        margin-right: 30px;
        min-height: 38px;
      }

      .form-group-control {
        /* max-width: calc(50% - 150px); */

        &.with-button {
          max-width: 100%;

          .form-group-inner-wrapper {
            .input-control {
              max-width: calc(((100% + 195px + 30px) / 2 ) - 150px);
            }
          }
        }
      }


      .message {
        padding-left: 11px;
        font-size: 11px;
        height: 18px;
        margin-bottom: 8px;

        &.is-password {
          margin-left: 180px;
        }
      }

      .note {
        min-height: 38px;
        margin-left: 11px;
      }
    }

    &.form-row {
      .form-col {
        .form-group {
          .form-group-control {
            max-width: none;
          }
        }
      }
    }

    &.form-group-title {
      padding: 10px 20px;
      margin-bottom: 20px;
    }
  }

  @media all and (max-width: 1366.98px) {
    &.page-topbar {
      .page-header {
        .page-icon {
          flex: 0 0 44px;
          height: 44px;

          .image-control {
            height: 18px;
          }
        }

        .title-and-breadcrumb {
          .title {
            font-size: 20px;
          }
        }
      }
    }

    &.main-content {
      padding: 20px;

      .content-body {
        .form-actions {
          margin-top: 35px;
          margin-bottom: 25px;
          padding: 0 15px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .content-footer {
        font-size: 13px;
      }

      &.form {
        min-height: calc(100vh - 267px);

        .form-actions {
          margin-top: 35px;
          margin-bottom: 25px;
          padding: 0 15px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .tooltip-upload {
      .tooltip-attachment {
        width: 14px;
      }
    }

    /*----------------------------
    -----   filter sidebar  ------
    ----------------------------*/
    /* &.filter-sidebar-wrapper {
      .title {
        font-size: 20px;
        margin-bottom: 33px;
      }

      .filter-group-header {
        &:before {
          width: 7px;
          flex: 0 0 7px;
          height: 7px;
          margin-right: 7px;
          margin-top: 7px;
        }
      }

      .filter {
        padding: 6px 9px;

        &.is-float-inside {
          height: 38px;

          .checkbox-group {
            .checkbox {
              &:last-child {
                margin-bottom: 7px;
              }
            }
          }
        }
      }

      .slider-wrapper {
        margin-bottom: 14px;
      }

      .select-control {
        margin-bottom: 14px;
      }
    } */

    &.checkbox-group {
      padding-left: 10px;

      .checkbox {
        margin-bottom: 7px;
      }

      .sub-group {
        padding-left: 16px;
      }
    }

    /* &.inside-filter {
      margin-top: 10px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_MD + 'px'
      };

      .action-wrapper {
        .filters {
          padding-right: 20px;

          .input-search-control {
            &.supplier-discovery {
              min-width: 160px;
              max-width: 300px;
            }
          }

          .search-note {
            font-size: 10px;
          }

          .select-control {
            &.category-filter {
              min-width: 180px;

              .select__menu {
                min-width: 270px;
              }
            }
          }
        }

        .sort-by-wrapper {
          .select-control {
            &.category-filter {
              min-width: 180px;
            }
          }
        }
      }
    } */

    /*----------------------------
    -----   Supplier Discovery block  ------
    ----------------------------*/
    /* &.supplier-discovery-block {
      min-height: 215px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_MD + 'px'
      };
      padding-top: 10px;
      padding-bottom: 28px;

      .info-wrapper {
        .supplier-header {
          margin-bottom: 18px;

          .supplier-name-and-address {
            min-width: 200px;

            .supplier-name-and-signs {
              padding-right: 28px;
              margin-bottom: 2px;

              .supplier-name {
                font-size: 16px;
              }

              .signs {
                margin-left: 12px;

                .button {
                  margin-right: 7px;

                  .image-control {
                    width: 15px;
                  }
                }

                .registration-status {
                  border-radius: 9px;
                  padding: 0 11px;
                  height: 21px;
                  line-height: 19px;
                  font-size: 10px;
                }

                .active-status,
                .wait-active-status,
                .seal-status,
                .not-regis-status {
                  margin: 0 0 0 8px;
                  padding: 0 10px;
                  height: 19px;
                  line-height: 16px;
                  font-size: 10px;
                }
              }
            }

            .supplier-address {
              font-size: 12px;
            }
          }
        }

        .supplier-info {
          .col {
            &:nth-child(2) {
              margin-left: 7px;

              .info-block {
                .label {
                  flex: 0 0 135px;
                }
              }
            }
          }

          .info-block {
            .label {
              flex: 0 0 125px;
              margin-right: 10px;
            }
          }
        }
      }

      .actions {
        flex: 0 0 200px;
        padding-top: 30px;

        .button {
          margin-bottom: 7px;
        }
      }
    } */

    /* &.supplier-discovery-information {
      .info-wrapper {
        .group-with-scoreboard {
          .detail-groups {
            min-width: 200px;
            padding-right: 15px;

            .detail-group {
              .label {
                width: 160px;
              }

              .data-control {
                min-width: 100px;
              }
            }
          }
        }

        .detail-group {
          margin-bottom: 10px;

          .label {
            flex: 0 0 160px;
            padding-right: 10px;
          }

          .data-control {
            .button {
              &.link {
                margin-left: 15px;
              }
            }

            .registration-status,
            .active-status,
            .not-regis-status,
            .wait-active-status {
              margin: 0 0 0 12px;
              border-radius: 8px;
              padding: 0 10px;
              height: 20px;
              font-size: 12px;
              line-height: 18px;
            }

            .data {
              a {
                &.file-link {
                  padding: 5px 13px 5px 34px;
                  max-width: 300px;
                  border-radius: 3px;
                  margin-bottom: 7px;
                  margin-right: 7px;

                  &:before {
                    width: 10px;
                    height: 13px;
                    margin-right: 12px;
                    left: 16px;
                  }
                }
              }
            }
          }
        }
      }

      .actions {
        flex: 0 0 160px;

        .button {
          margin-bottom: 7px;
        }
      }
    } */

    &.supplier-management-information {
      .info-wrapper {
        .detail-group {
          .label {
            flex: 0 0 190px;
            padding-right: 20px;
          }
        }
      }
    }

    /*----------------------------
    ----------   form  -----------
    ----------------------------*/
    &.form-wrapper {
      padding: 15px;

      /* .result-image {
        width: 200px;
        height: 113px;

        & > .image-control {
          width: 49px;
        }
      } */

      .info-wrapper {
        .detail-group {
          margin-bottom: 10px;

          .label {
            flex: 0 0 150px;
            padding-right: 35px;
          }
        }
      }
    }

    &.form-actions {
      padding: 0 15px;

      .button {
        width: 110px;
      }
    }

    &.form-group {
      .form-group-up {
        & > label {
          flex: 0 0 120px;
          margin-right: 30px;
          min-height: 36px;
        }

        .form-group-control {
          margin-top: 36px;

          /* .input-control {
            &.score {
              max-width: 80px;
              flex: 0 0 80px;
              min-width: 80px;
            }
          } */
        }

        .form-group-inner-wrapper {
          min-height: 36px;

          /* .button {
            width: 125px;
          }

          &.checkbox {
            & > .checkbox {
              margin-top: 8px;
            }
          } */
        }

      }

      .input-upload-control {
        max-width: 450px;
        flex: 0 0 450px;
        min-width: 200px;
      }

      .form-group-inner-wrapper {
        min-height: 36px;

        /* .button {
          width: 125px;
        }

        &.checkbox {
          & > .checkbox {
            margin-top: 8px;
          }
        } */
      }

      & > label {
        flex: 0 0 120px;
        margin-right: 25px;
        min-height: 36px;
      }

      .form-group-control {
        /* max-width: calc(50% - 145px); */

        &.with-button {
          max-width: 100%;

          .form-group-inner-wrapper {
            .input-control {
              max-width: calc(((100% + 195px + 30px) / 2 ) - 140px);
            }
          }
        }

        /* .input-control {
          &.score {
            max-width: 80px;
            flex: 0 0 80px;
            min-width: 80px;
          }
        } */
      }

      .button {
        margin-left: 14px;

        &.verify {
          flex: 0 0 120px;
        }

        &.resend-activation-email {
          flex: 0 0 190px;
          margin-top: 15px;
        }
      }

      .message {
        padding-left: 10px;
        font-size: 10px;
        height: 16px;
        margin-bottom: 7px;

        &.is-password {
          margin-left: 160px;
        }
      }

      .note {
        min-height: 36px;
        margin-left: 10px;
      }

      /* &.service-category {
        .add {
          .image-control {
            margin-right: 10px;
          }
        }
      }

      &.user-role {
        .checkbox-group {
          margin-top: 8px;
        }
      } */
    }

    &.form-group-title {
      padding: 9px 15px;
      margin-bottom: 15px;
    }
  }

  @media all and (max-width: 1280.98px) {
    &.page-topbar {
      margin-bottom: 0;

      .page-header {
        .page-icon {
          flex: 0 0 44px;
          height: 44px;
          margin-right: 12px;

          .image-control {
            height: 16px;
          }
        }

        .title-and-breadcrumb {
          .title {
            font-size: 20px;
          }
        }
      }
    }

    &.main-content {
      padding: 15px;

      .content-body {
        .form-actions {
          padding: 0 10px;
        }
      }

      .content-footer {
        font-size: 13px;
      }

      &.form {
        //min-height: calc(100vh - 267px);

        .form-actions {
          padding: 0 10px;
        }
      }
    }

    .tooltip-upload {
      .tooltip-attachment {
        width: 12px;
      }
    }

    &.attached-file-list {
      a {
        &.file-link {
          /* padding: 6px 15px 6px 40px; */
          /* max-width: 250px; */
          /* max-width: max-content;
          margin-right: 13px; */

          &:before {
            /* width: 12px;
            height: 15px;
            margin-right: 13px;
            left: 17px; */
          }

          .button {
            /* flex: 0 0 15px; */

            .delete-circle-icon {
              /* flex: 0 0 15px; */
            }
          }
        }
      }
    }

    /*----------------------------
    -----   filter sidebar  ------
    ----------------------------*/
    /* &.filter-sidebar-wrapper {
      padding: 0 10px;
      flex: 0 0 24%;

      .title {
        font-size: 18px;
        margin-bottom: 29px;
      }

      .filter-group-header {
        &:before {
          width: 6px;
          flex: 0 0 6px;
          height: 6px;
          margin-right: 6px;
          margin-top: 7px;
        }
      }

      .filter {
        padding: 5px 7px;

        &.is-float-inside {
          height: 36px;

          .checkbox-group {
            .checkbox {
              &:last-child {
                margin-bottom: 6px;
              }
            }
          }
        }
      }

      .slider-wrapper {
        margin-bottom: 12px;
      }

      .select-control {
        margin-bottom: 12px;
      }
    } */

    &.checkbox-group {
      padding-left: 5px;

      .checkbox {
        margin-bottom: 6px;
      }

      .sub-group {
        padding-left: 13px;
      }
    }

    /* &.inside-filter {
      margin-top: 10px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_SM + 'px'
      };

      .action-wrapper {
        flex-wrap: wrap;

        .filters {
          width: 100%;
          max-width: none;
          padding-right: 0;
          margin-bottom: 10px;

          .input-search-control {
            &.supplier-discovery {
              min-width: 160px;
              max-width: none;
            }
          }

          .total-supplier {
            flex: 0 0 130px;
            text-align: right;
          }

          .search-note {
            font-size: 11px;
          }
        }

        .sort-by-wrapper {
          .label {
            flex: 0 0 130px;
            text-align: right;
            justify-content: flex-end;
          }

          .select-control {
            &.category-filter {
              min-width: 180px;
            }
          }
        }
      }
    } */

    /*----------------------------
    -----   Supplier Discovery block  ------
    ----------------------------*/
    /* &.supplier-discovery-block {
      min-height: 180px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_SM + 'px'
      };
      padding-top: 10px;
      padding-bottom: 20px;

      .info-wrapper {
        .supplier-header {
          margin-bottom: 10px;

          .supplier-name-and-address {
            min-width: 170px;

            .supplier-name-and-signs {
              padding-right: 22px;

              .supplier-name {
                font-size: 15px;
              }

              .signs {
                margin-left: 10px;

                .button {
                  margin-right: 6px;

                  .image-control {
                    width: 14px;
                  }
                }

                .registration-status {
                  border-radius: 8px;
                  padding: 0 10px;
                  height: 20px;
                  line-height: 18px;
                }

                .active-status,
                .wait-active-status,
                .seal-status,
                .not-regis-status {
                  margin: 0 0 0 7px;
                  padding: 0 9px;
                  height: 20px;
                  line-height: 18px;
                }
              }
            }

            .supplier-address {
              font-size: 11px;
            }
          }
        }

        .supplier-info {
          .col {
            &:nth-child(2) {
              margin-left: 6px;

              .info-block {
                .label {
                  flex: 0 0 125px;
                }
              }
            }
          }

          .info-block {
            .label {
              flex: 0 0 110px;
              margin-right: 8px;
            }
          }
        }
      }

      .actions {
        flex: 0 0 180px;
        padding-top: 20px;

        .button {
          margin-bottom: 6px;
        }
      }
    } */

    /* &.supplier-discovery-information {
      .info-wrapper {
        .group-with-scoreboard {
          .detail-groups {
            padding-right: 5px;

            .detail-group {
              .label {
                width: 140px;
              }
            }
          }
        }

        .detail-group {
          margin-bottom: 8px;

          .label {
            flex: 0 0 140px;
          }

          .data-control {
            .button {
              &.link {
                margin-left: 15px;
              }
            }

            .registration-status,
            .active-status,
            .not-regis-status,
            .wait-active-status {
              margin: 0 0 0 10px;
              border-radius: 5px;
              padding: 0 8px;
              height: 20px;
              font-size: 11px;
              line-height: 18px;
            }

            .data {
              a {
                &.file-link {
                  padding: 5px 11px 5px 32px;
                  max-width: 250px;
                  border-radius: 3px;
                  margin-bottom: 6px;
                  margin-right: 6px;

                  &:before {
                    width: 9px;
                    height: 12px;
                    margin-right: 11px;
                    left: 15px;
                  }
                }
              }
            }
          }
        }
      }

      .actions {
        flex: 0 0 140px;

        .button {
          margin-bottom: 6px;
        }
      }
    } */

    &.supplier-management-information {
      .info-wrapper {
        .detail-group {
          .data-control {
            .data {
              .table {
                &.contact-detail {
                  margin-top: 10px;

                  .table-column {
                    font-size: 11px;

                    &.resend-activation-email {
                      padding-left: 5px;
                    }
                  }
                }
              }
            }
          }

          .label {
            flex: 0 0 170px;
            padding-right: 10px;
          }
        }
      }
    }

    /*----------------------------
    ----------   form  -----------
    ----------------------------*/
    &.form-wrapper {
      padding: 10px;

      /* .result-image {
        width: 200px;
        height: 113px;

        & > .image-control {
          width: 49px;
        }
      } */

      .info-wrapper {
        .detail-group {
          margin-bottom: 9px;

          .label {
            flex: 0 0 140px;
            padding-right: 30px;
          }
        }
      }
    }

    &.form-actions {
      .button {
        width: 100px;
      }
    }

    &.form-group {
      max-width: 600px;

      &.form-group-fluid {
        max-width: 100%;
      }

      .form-group-up {
        & > label {
          flex: 0 0 125px;
          margin-right: 25px;
          min-height: 36px;
        }

        .form-group-control {
          margin-top: 34px;

          /* .input-control {
            &.score {
              max-width: 80px;
              flex: 0 0 80px;
              min-width: 80px;
            }
          } */
        }

        .form-group-inner-wrapper {
          min-height: 34px;

          /* .button {
            width: 125px;
          }

          &.checkbox {
            & > .checkbox {
              margin-top: 8px;
            }
          } */
        }

      }

      .input-upload-control {
        &.is-horizontal {
          .button {
            margin-left: 10px;
            margin-top: 0;
          }

          &.is-hide-fake-input {
            .button {
              margin-left: 0;
            }
          }
        }
      }

      .form-group-inner-wrapper {
        min-height: 34px;

        /* .button {
          width: 125px;
        }

        &.checkbox {
          & > .checkbox {
            margin-top: 8px;
          }
        } */
      }

      & > label {
        flex: 0 0 125px;
        margin-right: 25px;
        min-height: 34px;
      }

      .form-group-control {
        max-width: calc(100% - 140px);

        &.form-group-control-fluid {
          max-width: 100%;
        }

        &.with-button {
          max-width: 100%;

          .form-group-inner-wrapper {
            flex-wrap: wrap;

            .input-control {
              max-width: 100%;
            }
          }
        }

        /* .input-control {
          &.score {
            max-width: 80px;
            flex: 0 0 80px;
            min-width: 80px;
          }
        } */
      }

      & > .button {
        margin-left: 0;
        margin-top: 10px;

        &.verify {
          flex: 0 0 110px;
        }

        &.resend-activation-email {
          flex: 0 0 170px;
        }
      }

      .message {
        padding-left: 9px;
        font-size: 9px;
        height: 14px;
        margin-bottom: 5px;

        &.is-password {
          margin-left: 150px;
        }
      }

      .note {
        min-height: 34px;
        margin-left: 9px;
      }

      /* &.service-category {
        .add {
          .image-control {
            margin-right: 10px;
          }
        }
      }

      &.user-role {
        .checkbox-group {
          margin-top: 8px;
        }
      } */

      &.upload-wrapper {
        .button {
          margin-top: 0;
          margin-left: 10px;
        }
      }
    }

    &.form-col {
      &.col-6 {
        width: 100%;
        flex: 0 0 100%;
        max-width: 600px;

        &.hide-mobile {
          display: none;
          width: 0;
          padding: 0;
          margin: 0;
        }
      }
    }

    &.form-group-header {
      &.grid-to-label {
        padding-left: 0;
      }
    }

    &.form-group-title {
      padding: 8px 15px;
    }

    &.form-row {
      &.time-left {
        .form-col {
          .form-group {
            max-width: 100%;
          }
        }
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    &.page-topbar {
      margin-bottom: 0;

      .page-header {
        .page-icon {
          flex: 0 0 44px;
          height: 44px;
          margin-right: 12px;

          .image-control {
            height: 14px;
          }
        }

        .title-and-breadcrumb {
          .title {
            font-size: 20px;
          }
        }
      }
    }

    &.main-content {
      padding: 10px;

      .content-body {
        .form-actions {
          margin-top: 25px;
          padding: 0 5px;
        }
      }

      .content-footer {
        font-size: 13px;
      }

      &.form {
        //min-height: calc(100vh - 267px);

        .form-actions {
          margin-top: 25px;
          padding: 0 5px;
        }
      }
    }

    .tooltip-upload {
      .tooltip-attachment {
        width: 11px;
        right: -16px;
      }
    }

    &.attached-file-list {
      a {
        &.file-link {
          /* padding: 5px 13px 5px 38px; */
          /* max-width: 220px; */
          /* max-width: max-content; */
          /* margin-right: 10px; */

          &:before {
            /* width: 11px;
            height: 14px;
            margin-right: 10px;
            left: 12px; */
          }

          .button {
            /* flex: 0 0 14px; */

            .delete-circle-icon {
              /* flex: 0 0 14px; */
            }
          }
        }
      }
    }

    /*----------------------------
    -----   filter sidebar  ------
    ----------------------------*/
    /* &.filter-sidebar-wrapper {
      flex: 0 0 25%;
      padding: 0 5px;

      .title {
        font-size: 16px;
        margin-bottom: 25px;
      }

      .filter-group-header {
        &:before {
          width: 5px;
          flex: 0 0 5px;
          height: 5px;
          margin-right: 5px;
          margin-top: 7px;
        }
      }

      .filter {
        padding: 5px;

        &.is-float-inside {
          height: 36px;

          .checkbox-group {
            .checkbox {
              margin-bottom: 5px;

              &:last-child {
                margin-bottom: 6px;
              }
            }
          }
        }
      }

      .slider-wrapper {
        margin-bottom: 12px;
      }

      .select-control {
        margin-bottom: 12px;
      }
    } */

    &.checkbox-group {
      padding-left: 0;

      .checkbox {
        margin-bottom: 5px;
      }

      .sub-group {
        padding-left: 10px;
      }
    }

    /* &.inside-filter {
      margin-top: 10px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_XS + 'px'
      };

      .action-wrapper {
        .filters {
          .search-note {
            font-size: 10px;
          }
        }

        .sort-by-wrapper {
          .select-control {
            &.category-filter {
              min-width: 160px;
            }
          }
        }
      }
    } */

    /*----------------------------
    -----   Supplier Discovery block  ------
    ----------------------------*/
    /* &.supplier-discovery-block {
      min-height: 160px;
      padding-left: ${
        VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_XS + 'px'
      };
      padding-bottom: 10px;

      .info-wrapper {
        .supplier-header {
          .supplier-name-and-address {
            min-width: 150px;

            .supplier-name-and-signs {
              padding-right: 15px;

              .supplier-name {
                font-size: 14px;
              }

              .signs {
                margin-left: 7px;

                .button {
                  margin-right: 5px;

                  .image-control {
                    width: 14px;
                  }
                }

                .registration-status {
                  border-radius: 8px;
                  padding: 0 10px;
                  height: 20px;
                  line-height: 18px;
                }

                .active-status,
                .wait-active-status,
                .seal-status,
                .not-regis-status {
                  margin: 0 0 0 7px;
                  padding: 0 9px;
                  height: 20px;
                  line-height: 18px;
                }
              }
            }

            .supplier-address {
              font-size: 10px;
            }
          }
        }

        .supplier-info {
          .col {
            width: 100%;

            &:nth-child(2) {
              margin-left: 0;

              .info-block {
                .label {
                  flex: 0 0 115px;
                }
              }
            }
          }

          .info-block {
            line-height: 1.6;

            .label {
              flex: 0 0 100px;
              margin-right: 8px;
            }
          }
        }
      }

      .actions {
        flex: 0 0 160px;
        padding-top: 10px;

        .button {
          margin-bottom: 5px;
        }
      }
    } */

    /* &.supplier-discovery-information {
      .info-wrapper {
        .group-with-scoreboard {
          .detail-groups {
            .detail-group {
              .label {
                width: 130px;
              }
            }
          }
        }

        .detail-group {
          margin-bottom: 5px;

          .label {
            flex: 0 0 130px;
          }

          .data-control {
            .button {
              &.link {
                margin-left: 15px;
              }
            }

            .registration-status,
            .active-status,
            .not-regis-status,
            .wait-active-status {
              margin: 0 0 0 5px;
              border-radius: 4px;
              padding: 0 5px;
              height: 18px;
              font-size: 10px;
              line-height: 16px;
            }

            .data {
              a {
                &.file-link {
                  padding: 5px 9px 5px 30px;
                  max-width: 200px;
                  border-radius: 3px;
                  margin-bottom: 5px;
                  margin-right: 5px;

                  &:before {
                    width: 8px;
                    height: 11px;
                    margin-right: 10px;
                    left: 14px;
                  }
                }
              }
            }
          }
        }
      }

      .actions {
        flex: 0 0 130px;

        .button {
          margin-bottom: 5px;
        }
      }
    } */

    &.supplier-management-information {
      .info-wrapper {
        .detail-group {
          .data-control {
            .data {
              .table {
                &.contact-detail {
                  .table-column {
                    font-size: 10px;

                    /* &.resend-activation-email {
                      padding-left: 0;
                    } */
                  }
                }
              }
            }
          }
        }
      }
    }

    /*----------------------------
    ----------   form  -----------
    ----------------------------*/
    &.form-wrapper {
      padding: 5px;
    }

    &.form-actions {
      .button {
        width: 85px;
      }
    }
  }

  @media screen and (max-width: 995.98px){
    /* flex-wrap: wrap; */

    &.supplier-management-information {
      .info-wrapper {
        .detail-group {
          .data-control {
            .data {
              .table {
                &.contact-detail {
                  width: fit-content;
                  .table-column {
                    font-size: 10px;

                    /* &.resend-activation-email {
                      padding-left: 0;
                    } */
                  }
                }
              }
            }

            .data-input {
            width: 100%;
            display: flex;

            .input-control {
              /* max-width: auto; */

              &.tag-relevant {
                width: auto;
                margin-right: 10px;
              }
            }

            &.tag-relevant {

              .button {
                padding-left: 45px;
                padding-right: 45px;
              }
            }
            }
          }
        }
      }
    }
  }
`
